export var ValueMultimediaFormat;
(function (ValueMultimediaFormat) {
    ValueMultimediaFormat["Aac"] = "AAC";
    ValueMultimediaFormat["Avi"] = "AVI";
    ValueMultimediaFormat["Bmp"] = "BMP";
    ValueMultimediaFormat["Epub"] = "ePUB";
    ValueMultimediaFormat["Flac"] = "FLAC";
    ValueMultimediaFormat["Gif"] = "GIF";
    ValueMultimediaFormat["Jpeg"] = "JPEG";
    ValueMultimediaFormat["Jpg"] = "JPG";
    ValueMultimediaFormat["Mkv"] = "MKV";
    ValueMultimediaFormat["Mobi"] = "mobi";
    ValueMultimediaFormat["Mp3"] = "MP3";
    ValueMultimediaFormat["Pcx"] = "PCX";
    ValueMultimediaFormat["Pdf"] = "PDF";
    ValueMultimediaFormat["Png"] = "PNG";
    ValueMultimediaFormat["Tiff"] = "TIFF";
    ValueMultimediaFormat["Tif"] = "TIF";
    ValueMultimediaFormat["Wav"] = "WAV";
})(ValueMultimediaFormat || (ValueMultimediaFormat = {}));
//# sourceMappingURL=ValueMultimediaFormat.js.map